import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AccountService } from 'src/app/services/account.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-restore',
  templateUrl: './restore.component.html',
  styleUrls: ['./restore.component.css']
})
export class RestoreComponent implements OnInit {
  progress = false;
  MensajeError = false;
  MensajeNoExisteCorreo = false;
  MensajeSucces = false;
  btnEnviar = false;
  RestoreForm: FormGroup;
  constructor(private router: Router, private fb: FormBuilder, private service: AccountService) {
    this.RestoreForm = fb.group({
      Correo: ['', [Validators.email, Validators.required, Validators.pattern(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)]],
      Correo2: ['', [Validators.email, Validators.required, Validators.pattern(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)]]
    });
  }

  ngOnInit(): void {
    // This is intentional
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  Solicitud() {
    this.validateAllFormFields(this.RestoreForm);
    if (this.RestoreForm.valid) {
      this.progress = true;
      this.btnEnviar = true;
      this.service.Recuperar(this.RestoreForm.controls['Correo'].value).subscribe(
        (data: any) => {
          if (data.Error == false) {
            this.RestoreForm.reset();
            this.MensajeSucces = true;
            setTimeout(() => {
              this.MensajeSucces = false;
              this.router.navigateByUrl('/');
            }, 2000);
          } else {
            if (data.MensajeRetorno == "No existe cuenta de acceso con el correo ingresado.") {
              this.MensajeNoExisteCorreo = true;
              setTimeout(() => {
                this.MensajeNoExisteCorreo = false;
              }, 5000);
            } else {
              this.MensajeError = true;

              setTimeout(() => {
                this.MensajeError = false;
              }, 5000);
            }

          }
          console.log(data);
        },
        (error) => {
          console.log(error);
          this.MensajeError = true;
          setTimeout(() => {
            this.MensajeError = true;
          }, 5000);
        },
        () => {
          this.btnEnviar = false;
          this.progress = false;
        }

      );


    }
  }

}
